import { useRef } from "react";
import clsx from "clsx";
import { StepperIndicator } from "./StepperIndicator";
import { StepperHeader } from "./StepperHeader";
import { StepperNavigationButtons } from "./StepperNavigationButtons";
import { StepperProps } from ".";

export function StepperDesktop({
  classNames,
  currentStep,
  isDisabled,
  nextButtonLabel = "Next",
  onNext,
  onPrevious,
  previousButtonLabel = "Previous",
  showStepIndicator = true,
  steps,
}: StepperProps) {
  const headerRef = useRef<HTMLDivElement>(null);

  if (steps.length === 0) {
    return <div>No steps provided</div>;
  }

  const isFirstStep = currentStep === 0;
  const step = steps[currentStep];

  const handleNext = () => {
    onNext();
  };

  return (
    <div className="flex h-full w-full flex-col justify-between">
      <div className={clsx(classNames?.content)}>
        <div ref={headerRef}>
          {showStepIndicator && <StepperIndicator currentStep={currentStep} totalSteps={steps.length} />}

          <StepperHeader title={step.title} description={step.description} badge={step.badge} />
        </div>
      </div>
      <div className="border-default mx-4 mt-8 flex h-full flex-col gap-3 rounded-xl border p-4">{step.content}</div>

      {/* Navigation Buttons */}
      <StepperNavigationButtons
        isDisabled={isDisabled}
        isFirstStep={isFirstStep}
        onNext={handleNext}
        onPrevious={onPrevious}
        nextButtonLabel={nextButtonLabel}
        previousButtonLabel={previousButtonLabel}
        classNames={classNames?.navigationButtons}
      />
    </div>
  );
}
